module.exports = __webpack_public_path__ + "img/logo-full-competti.5a246e6b.png";